/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiTeamTeamsEvanmiyaGet$Any } from '../fn/team/api-team-teams-evanmiya-get-any';
import { ApiTeamTeamsEvanmiyaGet$Any$Params } from '../fn/team/api-team-teams-evanmiya-get-any';
import { apiTeamTeamsEvanmiyaGet$Json } from '../fn/team/api-team-teams-evanmiya-get-json';
import { ApiTeamTeamsEvanmiyaGet$Json$Params } from '../fn/team/api-team-teams-evanmiya-get-json';
import { apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFull } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-full';
import { ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataFull$Params } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-full';
import { apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-full-odata-streaming-false';
import { ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-full-odata-streaming-false';
import { apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-full-odata-streaming-true';
import { ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-full-odata-streaming-true';
import { apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimal } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-minimal';
import { ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimal$Params } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-minimal';
import { apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNone } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-none';
import { ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataNone$Params } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-none';
import { apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-none-odata-streaming-false';
import { ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-none-odata-streaming-false';
import { apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-none-odata-streaming-true';
import { ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/team/api-team-teams-evanmiya-get-json-odata-metadata-none-odata-streaming-true';
import { apiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse } from '../fn/team/api-team-teams-evanmiya-get-json-odata-streaming-false';
import { ApiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse$Params } from '../fn/team/api-team-teams-evanmiya-get-json-odata-streaming-false';
import { apiTeamTeamsEvanmiyaGet$JsonOdataStreamingTrue } from '../fn/team/api-team-teams-evanmiya-get-json-odata-streaming-true';
import { ApiTeamTeamsEvanmiyaGet$JsonOdataStreamingTrue$Params } from '../fn/team/api-team-teams-evanmiya-get-json-odata-streaming-true';
import { apiTeamTeamsEvanmiyaGet$Plain } from '../fn/team/api-team-teams-evanmiya-get-plain';
import { ApiTeamTeamsEvanmiyaGet$Plain$Params } from '../fn/team/api-team-teams-evanmiya-get-plain';
import { apiTeamTeamsEvanmiyaGet$Xml } from '../fn/team/api-team-teams-evanmiya-get-xml';
import { ApiTeamTeamsEvanmiyaGet$Xml$Params } from '../fn/team/api-team-teams-evanmiya-get-xml';
import { apiTeamTeamsGet$Any } from '../fn/team/api-team-teams-get-any';
import { ApiTeamTeamsGet$Any$Params } from '../fn/team/api-team-teams-get-any';
import { apiTeamTeamsGet$Json } from '../fn/team/api-team-teams-get-json';
import { ApiTeamTeamsGet$Json$Params } from '../fn/team/api-team-teams-get-json';
import { apiTeamTeamsGet$JsonOdataMetadataFull } from '../fn/team/api-team-teams-get-json-odata-metadata-full';
import { ApiTeamTeamsGet$JsonOdataMetadataFull$Params } from '../fn/team/api-team-teams-get-json-odata-metadata-full';
import { apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/team/api-team-teams-get-json-odata-metadata-full-odata-streaming-false';
import { ApiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/team/api-team-teams-get-json-odata-metadata-full-odata-streaming-false';
import { apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/team/api-team-teams-get-json-odata-metadata-full-odata-streaming-true';
import { ApiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/team/api-team-teams-get-json-odata-metadata-full-odata-streaming-true';
import { apiTeamTeamsGet$JsonOdataMetadataMinimal } from '../fn/team/api-team-teams-get-json-odata-metadata-minimal';
import { ApiTeamTeamsGet$JsonOdataMetadataMinimal$Params } from '../fn/team/api-team-teams-get-json-odata-metadata-minimal';
import { apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/team/api-team-teams-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/team/api-team-teams-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/team/api-team-teams-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/team/api-team-teams-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiTeamTeamsGet$JsonOdataMetadataNone } from '../fn/team/api-team-teams-get-json-odata-metadata-none';
import { ApiTeamTeamsGet$JsonOdataMetadataNone$Params } from '../fn/team/api-team-teams-get-json-odata-metadata-none';
import { apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/team/api-team-teams-get-json-odata-metadata-none-odata-streaming-false';
import { ApiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/team/api-team-teams-get-json-odata-metadata-none-odata-streaming-false';
import { apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/team/api-team-teams-get-json-odata-metadata-none-odata-streaming-true';
import { ApiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/team/api-team-teams-get-json-odata-metadata-none-odata-streaming-true';
import { apiTeamTeamsGet$JsonOdataStreamingFalse } from '../fn/team/api-team-teams-get-json-odata-streaming-false';
import { ApiTeamTeamsGet$JsonOdataStreamingFalse$Params } from '../fn/team/api-team-teams-get-json-odata-streaming-false';
import { apiTeamTeamsGet$JsonOdataStreamingTrue } from '../fn/team/api-team-teams-get-json-odata-streaming-true';
import { ApiTeamTeamsGet$JsonOdataStreamingTrue$Params } from '../fn/team/api-team-teams-get-json-odata-streaming-true';
import { apiTeamTeamsGet$Plain } from '../fn/team/api-team-teams-get-plain';
import { ApiTeamTeamsGet$Plain$Params } from '../fn/team/api-team-teams-get-plain';
import { apiTeamTeamsGet$Xml } from '../fn/team/api-team-teams-get-xml';
import { ApiTeamTeamsGet$Xml$Params } from '../fn/team/api-team-teams-get-xml';
import { apiTeamTeamsRealgmGet$Any } from '../fn/team/api-team-teams-realgm-get-any';
import { ApiTeamTeamsRealgmGet$Any$Params } from '../fn/team/api-team-teams-realgm-get-any';
import { apiTeamTeamsRealgmGet$Json } from '../fn/team/api-team-teams-realgm-get-json';
import { ApiTeamTeamsRealgmGet$Json$Params } from '../fn/team/api-team-teams-realgm-get-json';
import { apiTeamTeamsRealgmGet$JsonOdataMetadataFull } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-full';
import { ApiTeamTeamsRealgmGet$JsonOdataMetadataFull$Params } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-full';
import { apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-full-odata-streaming-false';
import { ApiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-full-odata-streaming-false';
import { apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-full-odata-streaming-true';
import { ApiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-full-odata-streaming-true';
import { apiTeamTeamsRealgmGet$JsonOdataMetadataMinimal } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-minimal';
import { ApiTeamTeamsRealgmGet$JsonOdataMetadataMinimal$Params } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-minimal';
import { apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiTeamTeamsRealgmGet$JsonOdataMetadataNone } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-none';
import { ApiTeamTeamsRealgmGet$JsonOdataMetadataNone$Params } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-none';
import { apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-none-odata-streaming-false';
import { ApiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-none-odata-streaming-false';
import { apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-none-odata-streaming-true';
import { ApiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/team/api-team-teams-realgm-get-json-odata-metadata-none-odata-streaming-true';
import { apiTeamTeamsRealgmGet$JsonOdataStreamingFalse } from '../fn/team/api-team-teams-realgm-get-json-odata-streaming-false';
import { ApiTeamTeamsRealgmGet$JsonOdataStreamingFalse$Params } from '../fn/team/api-team-teams-realgm-get-json-odata-streaming-false';
import { apiTeamTeamsRealgmGet$JsonOdataStreamingTrue } from '../fn/team/api-team-teams-realgm-get-json-odata-streaming-true';
import { ApiTeamTeamsRealgmGet$JsonOdataStreamingTrue$Params } from '../fn/team/api-team-teams-realgm-get-json-odata-streaming-true';
import { apiTeamTeamsRealgmGet$Plain } from '../fn/team/api-team-teams-realgm-get-plain';
import { ApiTeamTeamsRealgmGet$Plain$Params } from '../fn/team/api-team-teams-realgm-get-plain';
import { apiTeamTeamsRealgmGet$Xml } from '../fn/team/api-team-teams-realgm-get-xml';
import { ApiTeamTeamsRealgmGet$Xml$Params } from '../fn/team/api-team-teams-realgm-get-xml';
import { apiTeamTeamsStatheadGet$Any } from '../fn/team/api-team-teams-stathead-get-any';
import { ApiTeamTeamsStatheadGet$Any$Params } from '../fn/team/api-team-teams-stathead-get-any';
import { apiTeamTeamsStatheadGet$Json } from '../fn/team/api-team-teams-stathead-get-json';
import { ApiTeamTeamsStatheadGet$Json$Params } from '../fn/team/api-team-teams-stathead-get-json';
import { apiTeamTeamsStatheadGet$JsonOdataMetadataFull } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-full';
import { ApiTeamTeamsStatheadGet$JsonOdataMetadataFull$Params } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-full';
import { apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-full-odata-streaming-false';
import { ApiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-full-odata-streaming-false';
import { apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-full-odata-streaming-true';
import { ApiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-full-odata-streaming-true';
import { apiTeamTeamsStatheadGet$JsonOdataMetadataMinimal } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-minimal';
import { ApiTeamTeamsStatheadGet$JsonOdataMetadataMinimal$Params } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-minimal';
import { apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiTeamTeamsStatheadGet$JsonOdataMetadataNone } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-none';
import { ApiTeamTeamsStatheadGet$JsonOdataMetadataNone$Params } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-none';
import { apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-none-odata-streaming-false';
import { ApiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-none-odata-streaming-false';
import { apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-none-odata-streaming-true';
import { ApiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/team/api-team-teams-stathead-get-json-odata-metadata-none-odata-streaming-true';
import { apiTeamTeamsStatheadGet$JsonOdataStreamingFalse } from '../fn/team/api-team-teams-stathead-get-json-odata-streaming-false';
import { ApiTeamTeamsStatheadGet$JsonOdataStreamingFalse$Params } from '../fn/team/api-team-teams-stathead-get-json-odata-streaming-false';
import { apiTeamTeamsStatheadGet$JsonOdataStreamingTrue } from '../fn/team/api-team-teams-stathead-get-json-odata-streaming-true';
import { ApiTeamTeamsStatheadGet$JsonOdataStreamingTrue$Params } from '../fn/team/api-team-teams-stathead-get-json-odata-streaming-true';
import { apiTeamTeamsStatheadGet$Plain } from '../fn/team/api-team-teams-stathead-get-plain';
import { ApiTeamTeamsStatheadGet$Plain$Params } from '../fn/team/api-team-teams-stathead-get-plain';
import { apiTeamTeamsStatheadGet$Xml } from '../fn/team/api-team-teams-stathead-get-xml';
import { ApiTeamTeamsStatheadGet$Xml$Params } from '../fn/team/api-team-teams-stathead-get-xml';
import { StringListResult } from '../models/string-list-result';
import { TeamModelListResult } from '../models/team-model-list-result';

@Injectable({ providedIn: 'root' })
export class TeamService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTeamTeamsGet()` */
  static readonly ApiTeamTeamsGetPath = '/api/team/teams';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataMinimal$Response(params?: ApiTeamTeamsGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataMinimal(params?: ApiTeamTeamsGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataFull$Response(params?: ApiTeamTeamsGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataFull(params?: ApiTeamTeamsGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataNone$Response(params?: ApiTeamTeamsGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataMetadataNone(params?: ApiTeamTeamsGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataStreamingTrue$Response(params?: ApiTeamTeamsGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataStreamingTrue(params?: ApiTeamTeamsGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataStreamingFalse$Response(params?: ApiTeamTeamsGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$JsonOdataStreamingFalse(params?: ApiTeamTeamsGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$Json$Response(params?: ApiTeamTeamsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$Json(params?: ApiTeamTeamsGet$Json$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$Xml$Response(params?: ApiTeamTeamsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$Xml(params?: ApiTeamTeamsGet$Xml$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$Plain$Response(params?: ApiTeamTeamsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$Plain(params?: ApiTeamTeamsGet$Plain$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$Any$Response(params?: ApiTeamTeamsGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
    return apiTeamTeamsGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsGet$Any(params?: ApiTeamTeamsGet$Any$Params, context?: HttpContext): Observable<TeamModelListResult> {
    return this.apiTeamTeamsGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamModelListResult>): TeamModelListResult => r.body)
    );
  }

  /** Path part for operation `apiTeamTeamsEvanmiyaGet()` */
  static readonly ApiTeamTeamsEvanmiyaGetPath = '/api/team/teams/evanmiya';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimal$Response(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimal(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFull$Response(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFull(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNone$Response(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNone(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataStreamingTrue$Response(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataStreamingTrue(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse$Response(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse(params?: ApiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$Json$Response(params?: ApiTeamTeamsEvanmiyaGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$Json(params?: ApiTeamTeamsEvanmiyaGet$Json$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$Xml$Response(params?: ApiTeamTeamsEvanmiyaGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$Xml(params?: ApiTeamTeamsEvanmiyaGet$Xml$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$Plain$Response(params?: ApiTeamTeamsEvanmiyaGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$Plain(params?: ApiTeamTeamsEvanmiyaGet$Plain$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsEvanmiyaGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$Any$Response(params?: ApiTeamTeamsEvanmiyaGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsEvanmiyaGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsEvanmiyaGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsEvanmiyaGet$Any(params?: ApiTeamTeamsEvanmiyaGet$Any$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsEvanmiyaGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /** Path part for operation `apiTeamTeamsRealgmGet()` */
  static readonly ApiTeamTeamsRealgmGetPath = '/api/team/teams/realgm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataMinimal$Response(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataMinimal(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataFull$Response(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataFull(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataNone$Response(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataMetadataNone(params?: ApiTeamTeamsRealgmGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataStreamingTrue$Response(params?: ApiTeamTeamsRealgmGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataStreamingTrue(params?: ApiTeamTeamsRealgmGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataStreamingFalse$Response(params?: ApiTeamTeamsRealgmGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$JsonOdataStreamingFalse(params?: ApiTeamTeamsRealgmGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$Json$Response(params?: ApiTeamTeamsRealgmGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$Json(params?: ApiTeamTeamsRealgmGet$Json$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$Xml$Response(params?: ApiTeamTeamsRealgmGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$Xml(params?: ApiTeamTeamsRealgmGet$Xml$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$Plain$Response(params?: ApiTeamTeamsRealgmGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$Plain(params?: ApiTeamTeamsRealgmGet$Plain$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsRealgmGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$Any$Response(params?: ApiTeamTeamsRealgmGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsRealgmGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsRealgmGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsRealgmGet$Any(params?: ApiTeamTeamsRealgmGet$Any$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsRealgmGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /** Path part for operation `apiTeamTeamsStatheadGet()` */
  static readonly ApiTeamTeamsStatheadGetPath = '/api/team/teams/stathead';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataMinimal$Response(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataMinimal(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataFull$Response(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataFull(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataNone$Response(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataMetadataNone(params?: ApiTeamTeamsStatheadGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataStreamingTrue$Response(params?: ApiTeamTeamsStatheadGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataStreamingTrue(params?: ApiTeamTeamsStatheadGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataStreamingFalse$Response(params?: ApiTeamTeamsStatheadGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$JsonOdataStreamingFalse(params?: ApiTeamTeamsStatheadGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$Json$Response(params?: ApiTeamTeamsStatheadGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$Json(params?: ApiTeamTeamsStatheadGet$Json$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$Xml$Response(params?: ApiTeamTeamsStatheadGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$Xml(params?: ApiTeamTeamsStatheadGet$Xml$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$Plain$Response(params?: ApiTeamTeamsStatheadGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$Plain(params?: ApiTeamTeamsStatheadGet$Plain$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTeamTeamsStatheadGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$Any$Response(params?: ApiTeamTeamsStatheadGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
    return apiTeamTeamsStatheadGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTeamTeamsStatheadGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTeamTeamsStatheadGet$Any(params?: ApiTeamTeamsStatheadGet$Any$Params, context?: HttpContext): Observable<StringListResult> {
    return this.apiTeamTeamsStatheadGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringListResult>): StringListResult => r.body)
    );
  }

}
